import {
  type ConnectionStatus,
  ConnectionStatusEnum,
  connectionStatusText,
  isConnectionError,
  isConnectionOnline,
  isConnectionRecovering,
  prettyName,
  Tbody,
  Th,
} from '@talos/kyoko';
import type { ReactNode } from 'react';
import { Wrapper } from './styles';

interface StatusTooltipProps {
  connectionStatus: ConnectionStatus | undefined;
}

export function ConnectionStatusTooltip({ connectionStatus }: StatusTooltipProps): ReactNode {
  const isRecovering = isConnectionRecovering(connectionStatus);
  const isOnline = isConnectionOnline(connectionStatus);
  const isError = isConnectionError(connectionStatus);

  if (isOnline) {
    return null;
  }

  return isRecovering ? (
    <>Recovering</>
  ) : (
    <Wrapper>
      <Tbody>
        <tr>
          <Th colSpan={2}>
            <strong>
              {connectionStatusText(connectionStatus?.Status ?? ConnectionStatusEnum.Unavailable)}
              {isError ? ` - ${prettyName(connectionStatus?.ErrorCode ?? 'Connection status not found')}` : ''}
            </strong>
            {isError ? (
              <>
                <br />
                <div style={{ whiteSpace: 'break-spaces' }}>({connectionStatus?.Text})</div>
              </>
            ) : null}
          </Th>
        </tr>
      </Tbody>
    </Wrapper>
  );
}
